// extracted by mini-css-extract-plugin
export default {"selectCard":"selectCard_selectCard__Djjc0"};